const init = async () => {

	await import( './skatepark' );

};

init();

